import React, { useEffect, useState } from "react";
import {
  FileText,
  ArrowUpRight,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  X,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../api/api";

const API_URL = `${API_BASE_URL}/home-documents?limit=6`;

const SLIDER_IMAGES = [
  "/images/Cover_governer_image.jpeg",
  "/images/Government_Office.png",
  "/images/slide_3.jpeg",
  "/images/slide_4.jpeg",
];

const PROFILES = [
  {
    image: "/images/Governer_img.jpeg",
    name: "Dr. Dhal Singh Bisen",
    designation: "Governor, Uttarakhand & Chancellor of the University",
  },
  {
    image: "/images/cm_ku.jpg",
    name: "Shri Pushkar Singh Dhami",
    designation: "Chief Minister, Uttarakhand",
  },
  {
    image: "/images/minister_ku.jpg",
    name: "Dr. Dhan Singh Rawat",
    designation: "Minister, Technical Education, Uttarakhand",
  },
  {
    image: "/images/Satya_pal_vc.jpeg",
    name: "Prof. Satpal Singh Bisht",
    designation: "Vice-Chancellor",
    messageUrl: "/about/vice-chancellors-message",
    profileUrl: "/about/vice-chancellor-profile",
  },
];

export default function Hero() {
  const navigate = useNavigate();

  const [currentImage, setCurrentImage] = useState(0);
  const [documents, setDocuments] = useState([]);
  const [active, setActive] = useState("");
  const [openDropdown, setOpenDropdown] = useState(false);
  const [loading, setLoading] = useState(true);

  // Automatic image slider
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage(
        (prev) => (prev + 1) % SLIDER_IMAGES.length
      );
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  // Fetch notices
  useEffect(() => {
    const controller = new AbortController();

    async function fetchDocuments() {
      try {
        const response = await fetch(API_URL, {
          signal: controller.signal,
        });

        if (!response.ok) {
          throw new Error(`HTTP Error: ${response.status}`);
        }

        const result = await response.json();

        if (
          result.status === true &&
          Array.isArray(result.data)
        ) {
          const activeDocuments = result.data.filter(
            (item) => Number(item.status) === 1
          );

          setDocuments(activeDocuments);

          const firstEventType = activeDocuments.find(
            (item) => item.event_type
          )?.event_type;

          if (firstEventType) {
            setActive(firstEventType);
          }
        } else {
          setDocuments([]);
        }
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("Error fetching notices:", error);
          setDocuments([]);
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    }

    fetchDocuments();

    return () => controller.abort();
  }, []);

  // Unique categories
  const dynamicTabs = [
    ...new Set(
      documents.map((item) => item.event_type).filter(Boolean)
    ),
  ];

  // Latest 3 notices
  const currentDocuments = documents
    .filter((item) => item.event_type === active)
    .slice(0, 3);

  const formatEventType = (value) => {
    if (!value) return "";

    return value
      .replace(/[-_]/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  // Category dropdown
  const handleTabClick = (eventType) => {
    if (active === eventType && openDropdown) {
      setOpenDropdown(false);
    } else {
      setActive(eventType);
      setOpenDropdown(true);
    }
  };

  // Open full notice listing
  const showAllNotices = () => {
    if (!active) return;

    setOpenDropdown(false);
    navigate(`/notices?tab=${encodeURIComponent(active)}`);
  };

  return (
   <section
  id="home"
  className="relative z-10 min-h-[550px] w-full overflow-visible bg-white"
>
      {/* MAIN THREE-COLUMN LAYOUT */}
      
       <div className="relative grid w-full max-w-full min-w-0 grid-cols-12 items-stretch overflow-x-clip">
       {/* <div className="relative grid w-full max-w-full min-w-0 grid-cols-1 items-stretch overflow-x-clip lg:grid-cols-[minmax(0,1fr)_250px]"> */}
        {/* =====================================
            LEFT: NOTICE BOARD
        ===================================== */}
       {/* <aside className="relative z-0 col-span-12 flex min-w-0 flex-col justify-start gap-5 border-t border-gray-200 bg-white p-2 lg:col-span-2 lg:min-h-[550px] lg:border-l lg:border-t-0">
          <div className="mb-3 border-b border-[#e7d5c7] pb-2">
            <h2 className="text-lg font-bold text-[#8b2f1e]">
              Notice Board
            </h2>
            <p className="mt-1 text-xs text-gray-500">
              Latest university updates
            </p>
          </div>

          {loading && (
            <p className="py-4 text-sm text-gray-500">
              Loading notices...
            </p>
          )}

         
          {!loading && dynamicTabs.length > 0 && (
            <div className="flex flex-wrap gap-5 lg:flex-col">
              {dynamicTabs.map((eventType) => {
                const isActive = active === eventType;
                const isOpen = isActive && openDropdown;

                return (
                  <button
                    key={eventType}
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => handleTabClick(eventType)}
                    className={`flex w-full items-center gap-2 rounded-lg border px-3 py-2.5 text-left text-xs font-semibold transition-all ${
                      isActive
                        ? "border-[#8b2f1e] bg-[#8b2f1e] text-white"
                        : "border-gray-200 bg-white text-gray-700 hover:border-[#8b2f1e] hover:text-[#8b2f1e]"
                    }`}
                  >
                    <FileText size={15} className="shrink-0" />

                    <span className="min-w-0 flex-1">
                      {formatEventType(eventType)}
                    </span>

                    <ChevronDown
                      size={15}
                      className={`shrink-0 transition-transform ${
                        isOpen ? "rotate-180" : ""
                      }`}
                    />
                  </button>
                );
              })}
            </div>
          )}

          {!loading && dynamicTabs.length === 0 && (
            <p className="py-4 text-sm text-gray-500">
              No notices available.
            </p>
          )}
        </aside> */}

        {/* =====================================
            CENTER: IMAGE SLIDER
        ===================================== */}
      {/* <div className="relative z-0 col-span-12 min-w-0 bg-gray-100 lg:col-span-8">
         <div className="relative h-[400px] overflow-hidden sm:h-[500px] lg:h-[550px]">

            {SLIDER_IMAGES.map((image, index) => (
              <img
                key={image}
                src={image}
                alt={`Kumaun University slide ${index + 1}`}
                className={`absolute inset-0 h-full w-full object-contain object-center transition-opacity duration-1000 ${
                  currentImage === index
                    ? "opacity-100"
                    : "pointer-events-none opacity-0"
                }`}
              />
            ))}

         
            <button
              type="button"
              onClick={() =>
                setCurrentImage(
                  (prev) =>
                    (prev - 1 + SLIDER_IMAGES.length) %
                    SLIDER_IMAGES.length
                )
              }
              aria-label="Previous slide"
              className="absolute left-2 top-1/2 -translate-y-1/2 rounded-full bg-black/50 p-2 text-white hover:bg-black/75"
            >
              <ChevronLeft size={24} />
            </button>

            
            <button
              type="button"
              onClick={() =>
                setCurrentImage(
                  (prev) => (prev + 1) % SLIDER_IMAGES.length
                )
              }
              aria-label="Next slide"
              className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full bg-black/50 p-2 text-white hover:bg-black/75"
            >
              <ChevronRight size={24} />
            </button>

          
            <div className="absolute bottom-3 left-0 right-0 flex justify-center gap-2">
              {SLIDER_IMAGES.map((image, index) => (
                <button
                  key={image}
                  type="button"
                  onClick={() => setCurrentImage(index)}
                  aria-label={`Go to slide ${index + 1}`}
                  className={`h-2.5 rounded-full transition-all ${
                    currentImage === index
                      ? "w-7 bg-white"
                      : "w-2.5 bg-white/60"
                  }`}
                />
              ))}
            </div>
          </div>
        </div> */}
        <div className="relative z-0 col-span-12 min-w-0 bg-gray-100 lg:col-span-9">
  <div className="relative h-[400px] overflow-hidden bg-white sm:h-[500px] lg:h-[550px]">

    {/* UTTARAKHAND MOUNTAINS BACKGROUND */}
    {/* <div
      className="absolute inset-0 z-0 pointer-events-none"
      style={{
        backgroundImage: "url('/images/uttarakhand-mountains2.webp')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        opacity: 0.18,
      }}
    /> */}

    {/* SLIDER IMAGES */}
    {SLIDER_IMAGES.map((image, index) => (
      <img
        key={image}
        src={image}
        alt={`Kumaun University slide ${index + 1}`}
        className={`absolute inset-0 z-10 h-full w-full object-fit object-center transition-opacity duration-1000 ${
          currentImage === index
            ? "opacity-80"
            : "pointer-events-none opacity-0"
        }`}
      />
    ))}

    {/* PREVIOUS */}
    <button
      type="button"
      onClick={() =>
        setCurrentImage(
          (prev) =>
            (prev - 1 + SLIDER_IMAGES.length) %
            SLIDER_IMAGES.length
        )
      }
      aria-label="Previous slide"
      className="absolute left-2 top-1/2 z-20 -translate-y-1/2 rounded-full bg-black/50 p-2 text-white hover:bg-black/75"
    >
      <ChevronLeft size={24} />
    </button>

    {/* NEXT */}
    <button
      type="button"
      onClick={() =>
        setCurrentImage(
          (prev) => (prev + 1) % SLIDER_IMAGES.length
        )
      }
      aria-label="Next slide"
      className="absolute right-2 top-1/2 z-20 -translate-y-1/2 rounded-full bg-black/50 p-2 text-white hover:bg-black/75"
    >
      <ChevronRight size={24} />
    </button>

    {/* SLIDER INDICATORS */}
    <div className="absolute bottom-3 left-0 right-0 z-20 flex justify-center gap-2">
      {SLIDER_IMAGES.map((image, index) => (
        <button
          key={image}
          type="button"
          onClick={() => setCurrentImage(index)}
          aria-label={`Go to slide ${index + 1}`}
          className={`h-2.5 rounded-full transition-all ${
            currentImage === index
              ? "w-7 bg-white"
              : "w-2.5 bg-white/60"
          }`}
        />
      ))}
    </div>

  </div>
</div>

        {/* =====================================
            RIGHT: PROFILE CARDS
        ===================================== */}
          {/* <aside className="relative z-0 flex flex-col justify-start gap-1 border-t border-gray-200 bg-white p-2 lg:border-l lg:border-t-0">

        {PROFILES.map((profile) => (
          <div
            key={profile.name}
            className="flex min-h-[64px] items-center gap-2 rounded-xl border border-gray-300 bg-white p-2 transition-shadow hover:shadow-md"
          >
            <img
              src={profile.image}
              alt={profile.name}
              className="h-20 w-20 shrink-0 rounded-full border border-gray-200 object-cover"
            />

            <div className="min-w-0 flex-1">
              <h3 className="font-serif text-sm font-bold leading-tight text-[#8b2f1e]">
                {profile.name}
              </h3>

              <p className="mt-1 text-xs leading-4 text-gray-700">
                {profile.designation}
              </p>
            </div>
          </div>
        ))}

          </aside> */}
    
        {/* RIGHT: PROFILE CARDS */}

     <aside className="relative z-0 col-span-12 flex min-w-0 flex-col justify-start gap-8 border-t border-gray-200 bg-white p-2 lg:col-span-3 lg:min-h-[550px] lg:border-l lg:border-t-0">

          {PROFILES.map((profile) => (
            <div
              key={profile.name}
              className="flex flex-col gap-2 rounded-xl border border-gray-300 bg-white p-2 transition-shadow hover:shadow-md"
            >
              {/* Profile Information */}
              <div className="flex items-center gap-2">
                <img
                  src={profile.image}
                  alt={profile.name}
                  className="h-20 w-20 shrink-0 rounded-full border border-gray-200 object-cover"
                />

                <div className="min-w-0 flex-1">
                  <h3 className="font-serif text-sm font-bold leading-tight text-[#8b2f1e]">
                    {profile.name}
                  </h3>

                  <p className="mt-1 text-xs leading-4 text-gray-700">
                    {profile.designation}
                  </p>
                </div>
              </div>

              {/* Buttons: Show only when URLs are available */}
              {/* Buttons: Only for profiles with URLs */}
              {(profile.messageUrl || profile.profileUrl) && (
                <div className="flex flex-wrap gap-2">

                  {profile.messageUrl && (
                    <a
                      href={profile.messageUrl}
                      className="flex-1 rounded-md bg-[#8b2f1e] px-3 py-2 text-center text-xs font-semibold text-white transition hover:bg-[#6f2418]"
                    >
                      Message
                    </a>
                  )}

                  {profile.profileUrl && (
                    <a
                      href={profile.profileUrl}
                      className="flex-1 rounded-md border border-[#8b2f1e] px-3 py-2 text-center text-xs font-semibold text-[#8b2f1e] transition hover:bg-[#8b2f1e] hover:text-white"
                    >
                      Profile
                    </a>
                  )}

                </div>
              )}
            </div>
          ))}

        </aside>


        {/* =====================================
            NOTICE DROPDOWN OVERLAY
            DESKTOP: BESIDE NOTICE BOARD
            OVER THE SLIDER
        ===================================== */}
      
        {openDropdown && active && !loading && (
          <div
            className="
              absolute
              left-2
              right-2
              top-[305px]
              z-[60]
              mt-2
              rounded-xl
              border border-[#e7d5c7]
              bg-white
              p-3
              shadow-2xl

              sm:top-[425px]

              lg:left-[250px]
              lg:right-[250px]
              lg:top-3
              lg:mt-0
              lg:max-w-[420px]
            "
          >

            {/* DROPDOWN HEADER */}
            <div className="mb-3 flex items-center justify-between gap-2 border-b border-gray-100 pb-2">
              <h3 className="text-sm font-bold text-[#8b2f1e]">
                Latest {formatEventType(active)}
              </h3>

              <button
                type="button"
                onClick={() => setOpenDropdown(false)}
                aria-label="Close dropdown"
                className="rounded-md p-1 text-gray-500 hover:bg-gray-100"
              >
                <X size={18} />
              </button>
            </div>

            {/* NOTICE LIST */}
            <div className="max-h-[300px] space-y-2 overflow-y-auto">
              {currentDocuments.length > 0 ? (
                currentDocuments.map((item) => {
                  const documentUrl =
                    item.pdf_path || item.external_link;

                  return (
                    <a
                      key={item.id}
                      href={documentUrl || undefined}
                      target={documentUrl ? "_blank" : undefined}
                      rel={
                        documentUrl
                          ? "noopener noreferrer"
                          : undefined
                      }
                      onClick={(event) => {
                        if (!documentUrl) {
                          event.preventDefault();
                        }
                      }}
                      className="group block rounded-lg border border-gray-200 p-2.5 hover:border-[#8b2f1e] hover:bg-[#fffaf4]"
                    >
                      <p className="text-xs leading-5 text-gray-800 group-hover:text-[#8b2f1e]">
                        {item.heading}
                      </p>

                      {item.publish_date && (
                        <p className="mt-1 text-[10px] text-gray-500">
                          {item.publish_date}
                        </p>
                      )}

                      {documentUrl && (
                        <span className="mt-1 inline-flex items-center gap-1 text-[10px] font-semibold text-[#8b2f1e]">
                          Open Notice
                          <ArrowUpRight size={11} />
                        </span>
                      )}
                    </a>
                  );
                })
              ) : (
                <p className="py-4 text-center text-xs text-gray-500">
                  No documents available.
                </p>
              )}
            </div>

            {/* VIEW ALL */}
            <button
              type="button"
              onClick={showAllNotices}
              className="mt-3 flex w-full items-center justify-center gap-2 rounded-lg border border-[#8b2f1e] px-3 py-2.5 text-xs font-bold text-[#8b2f1e] hover:bg-[#8b2f1e] hover:text-white"
            >
              View All
              <ArrowUpRight size={14} />
            </button>
          </div>
        )}

      </div>
    </section>
  );
}
